/*
 * @Author: 王枫叶
 * @Date: 2020-10-13 17:37:19
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-17 21:44:43
 */
// 活动管理接口
import activeApi from "./activeManagement";
// 系统管理接口
import admApi from "./administrators";
// 广告管理api接口
import adsApi from "./advertisingManagement";
// 代理管理Api接口
import angentApi from "./angentManagement";
// 权限管理接口
import authorApi from "./author";
import businessmanApi from "./businessman";
import balanceApi from "./balance";
// 渠道后台管理api
import channelBApi from "./channelBackground";
// 渠道管理api
import channelApi from "./channelManagement";
import homeApi from "./home";
// 热点管理接口
import hotApi from "./hotManagement";
// 落地页配置接口
import LandPageApi from "./landPage";
// 登陆api接口
import loginApi from "./login";
// 产品管理api接口
import productApi from "./productManagement";
// 机器人借口管理
import roBotApi from "./robot";
// 统计管理接口
import staticsAPi from "./statistics";
// 系统管理api接口
import systemApi from "./systemManagement";
// 热点管理接口
import systemMessage from "./systemMessage";
// 交易管理api接口
import transApi from "./transactionManagement";
// 用户api接口
import userApi from "./user";
// 视频api接口
import videoApi from "./videoManagement";
// 商区代理接口
import angentDistrictApi from "./agentDistrictProvider";
//楼凤模块接口
import loufApi from "./loufeng";
//小说管理接口
import fictionApi from "./fiction";
//av解说管理接口
import avCommentApi from "./avComment";
// 系统消息
import sysMsgApi from "./sysmsg";
// 金刚区配置接口
import jgDistrictConfigApi from './jgDistrictConfig'
// 模块接口
import moduleApi from "./module";
// 导航广告
import technologyApi from "./technology";

const Api = Object.assign({
    ...sysMsgApi,
    ...technologyApi,
    ...loginApi,
    ...videoApi,
    ...userApi,
    ...productApi,
    ...transApi,
    ...adsApi,
    ...admApi,
    ...authorApi,
    ...systemApi,
    ...activeApi,
    ...angentApi,
    ...staticsAPi,
    ...channelApi,
    ...channelBApi,
    ...homeApi,
    ...LandPageApi,
    ...hotApi,
    ...systemMessage,
    ...roBotApi,
    ...businessmanApi,
    ...balanceApi,
    ...angentDistrictApi,
    ...loufApi,
    ...fictionApi,
    ...avCommentApi,
    ...moduleApi,
    ...jgDistrictConfigApi
});
export default Api;
